import React, { useEffect, useState } from "react";

import SendIcon from "@mui/icons-material/Send";
import { Box, Button, Stack, TextField } from "@mui/material";

import { ClipLoader } from "react-spinners";

import {
    getEvents,
    getImpactActionTrackers,
    getImpactCampaigns,
    postConnectImpact,
} from "helpers/destinations/createDestination";

import DynamicFieldTable from "components/organisms/DynamicFieldTable";

const Impact = ({
    destinationCode,
    setButtonDisabledStatus,
    onDestinationIDChange,
    onFieldsChange,
}) => {
    const [destinationID, setDestinationID] = useState(null);
    const [pixelID, setPixelID] = useState(null);
    const [token, setToken] = useState(null);
    const [isConnectLoading, setIsConnectLoading] = useState(false);

    const [campaigns, setCampaigns] = useState([]);
    const [events, setEvents] = useState([]);
    const [fields, setFields] = useState([
        {
            event_name: {
                options: [],
                isLoading: false,
                value: null,
            },
            campaign_id: {
                options: [],
                isLoading: false,

                value: null,
            },
            action_tracker_id: {
                options: [],
                isLoading: false,
                value: null,
            },
        },
    ]);

    const getActionTrackers = async (campaignID) => {
        const response = await getImpactActionTrackers(
            destinationID,
            campaignID,
        );
        if (response.status) {
            return response.data?.map((actionTracker) => ({
                label: actionTracker?.action_tracker_name,
                value: actionTracker?.action_tracker_id,
            }));
        }
    };
    const fetchCampaigns = async (destinationID) => {
        const response = await getImpactCampaigns(destinationID);
        if (response.status) {
            const options = response.data?.map((campaignId) => ({
                label: campaignId?.campaign_name,
                value: campaignId?.campaign_id,
            }));

            setCampaigns(options);
            setFields(
                fields?.map((field) => {
                    field.campaign_id.options = options;
                    return field;
                }),
            );
        }
    };

    const fetchEvents = async () => {
        const response = await getEvents();
        if (response.status) {
            const options = response.data?.events?.map((event) => ({
                label: event?.name,
                value: event?.code,
            }));

            setEvents(options);
            setFields(
                fields?.map((field) => {
                    field.event_name.options = options;
                    return field;
                }),
            );
        }
    };

    const connectImpact = async () => {
        setIsConnectLoading(true);
        const response = await postConnectImpact({
            pixel_id: pixelID,
            token,
            destination_type: "imcapi",
            create_pixel: false,
        });
        const id = response?.data?.[0]?.id;
        if (response.status) {
            await fetchEvents();
            await fetchCampaigns(id);
            setDestinationID(id);
            onDestinationIDChange(id);
            setButtonDisabledStatus(true);
        }

        setIsConnectLoading(false);
    };
    const fieldsConfiguration = [
        {
            name: "event_name",
            label: "Event Name",
            defaultValue: null,
            variant: "SELECT",
        },
        {
            name: "campaign_id",
            label: "Campaign ID",
            defaultValue: null,
            variant: "SELECT",
        },
        {
            name: "action_tracker_id",
            label: "Action Tracker ID",
            defaultValue: null,
            variant: "SELECT",
        },
    ];

    useEffect(() => {
        setButtonDisabledStatus(true);
    }, []);

    useEffect(() => {
        setFields(
            fields?.map((field) => {
                field.event_name.options = events;
                field.campaign_id.options = campaigns;
                return field;
            }),
        );
    }, [fields?.length]);
    useEffect(() => {
        onFieldsChange(fields);
    }, [fields]);
    return (
        destinationCode === "imcapi" && (
            <>
                {!destinationID && !events?.length && !campaigns?.length && (
                    <>
                        <TextField
                            name="pixel_id"
                            className="text-field-ui-workaround"
                            label={"Pixel ID"}
                            variant="outlined"
                            onChange={(e) => {
                                setPixelID(e.target.value);
                            }}
                            value={pixelID}
                            fullWidth
                            disabled={destinationID}
                        />
                        <TextField
                            name="token"
                            className="text-field-ui-workaround mt-3"
                            label={"Token"}
                            variant="outlined"
                            onChange={(e) => {
                                setToken(e.target.value);
                            }}
                            value={token}
                            fullWidth
                            disabled={destinationID}
                        />
                        <div className="position-relative overflow-hidden z-1  mt-3">
                            {isConnectLoading && (
                                <div className="circle-loader max-height-45">
                                    <ClipLoader color={"#000"} size={17} />
                                </div>
                            )}
                            <Button
                                variant="outlined"
                                color="primary"
                                className="btn btn-block source-button-mui impactBtn"
                                onClick={connectImpact}
                                disabled={destinationID || !pixelID || !token}
                            >
                                <img
                                    className="px-1"
                                    style={{
                                        display: "inline-block",
                                    }}
                                    src="/assets/images/typeImages/impact.png"
                                    width="30"
                                    alt="impact-logo"
                                />
                                <Box>continue with impact</Box>
                            </Button>
                        </div>
                    </>
                )}
                {destinationID && !!events?.length && !!campaigns?.length && (
                    <DynamicFieldTable
                        isScrollable={false}
                        maxHeight={null}
                        minLength={1}
                        fields={fields}
                        setFields={setFields}
                        showStatus={false}
                        fieldsConfiguration={fieldsConfiguration}
                        onFieldsChange={async ({ rowIndex, name, value }) => {
                            if (name === "campaign_id" && value) {
                                setFields(
                                    fields?.map((field, index) => {
                                        if (rowIndex === index) {
                                            field[rowIndex][name].isLoading =
                                                true;
                                        }
                                        return field;
                                    }),
                                );
                                const actionTrackers =
                                    await getActionTrackers(value);
                                setFields(
                                    fields?.map((field, index) => {
                                        if (rowIndex === index) {
                                            field[rowIndex][name].isLoading =
                                                false;
                                            field[rowIndex][name].options =
                                                actionTrackers?.map(
                                                    (actionTracker) => ({
                                                        label: actionTracker?.action_tracker_name,
                                                        value: actionTracker?.action_tracker_id,
                                                    }),
                                                );
                                        }
                                        return field;
                                    }),
                                );
                            }
                        }}
                    />
                )}
            </>
        )
    );
};

export default Impact;
